export const CheckResource = {
  "CheckSuccess": "Grammar verification passed!",
  "ConfirmWhenError": "The possible grammar issues are as follows. Do you still want to save them?",
  "EsprimaSplit": "】-->【",
  "ErrorText": "Error in row {0}, column {1} due to 【{2}】. Please check if the red underline and nearby syntax are normal!",
  "ErrorDetail": "There are {0} exceptions, with detailed information as follows:",
  "Error": "Error",
  "ContextNotSet": "In line {0}, the context variable --> is not set",
  "SessionNotSet": "In line {0}, the session variable --> is not set",
  "ContextNotExist": "In line {0}, the context variable 【{1}】 --> does not exist",
  "SessionNotExist": "In line {0}, the session variable 【{1}】 --> does not exist",
  "ParamIllegal": "In line {0}, the parameter of function 【{1}】 is illegal. Please check!",
  "ParamArrayIllegal": "In line {0}, the array type parameter of function 【{1}】 is illegal. Please check!",
  "ParamNumberWithZero": "In line {0}, the number of parameters for function 【{1}】 does not match. Expected 0 or {2}, actual {3}, please check!",
  "ParamNumber": "In line {0}, the number of parameters for function 【{1}】 does not match. Expected {2}, actual {3}, please check!",
  "SimpleNoProperty": "In line {0}, the regular attribute 【{1}】 has no sub attributes",
  "ChildNoProperty": "In row {0}, sub table 【{1}】 does not have attribute 【{2}】",
  "PropertyNoProperty": "In line {0}, field 【{1}】 does not have attribute 【{2}】",
  "AddTwoManyParameters": "In line {0}, there are too many parameters for function [{1}], please check!",
  "Token": "Unexpected token",
  "ILLEGAL": "Unexpected token ILLEGAL",
  "EndOfInpur": "Unexpected end of input"
}